


























import Vue from 'vue'
import Component from 'vue-class-component'

import 'tui-image-editor/dist/tui-image-editor.css'

require('tui-image-editor/dist/svg/icon-a.svg')
require('tui-image-editor/dist/svg/icon-b.svg')
require('tui-image-editor/dist/svg/icon-c.svg')
require('tui-image-editor/dist/svg/icon-d.svg')

import {ImageEditor as ImageEditorComponent} from '@toast-ui/vue-image-editor';
import TuiImageEditor from 'tui-image-editor'
import {State} from 'vuex-class';
import {MediaObject} from '@/modules/media/types';
import {notify} from '@/modules/core/notification';

/**
 * Editor de imágenes
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'tui-image-editor': ImageEditorComponent,
    },
})
export default class ImageEditor extends Vue {
    public $refs: Vue['$refs'] & {
        editor: {
            editorInstance: TuiImageEditor,
        },
    }

    /**
     * Archivo multimedia actualmente en edición por el usuario
     *
     * @var { Media }
     */
    @State(state => state.media.currentMedia)
    public media: MediaObject

    public saving = false
    public saveConfirm = false


    public async mounted () {
        if (!this.media || !this.media.isImage) {
            notify('No se puede editar el archivo')

            return this.$router.push('dashboard')
        }
    }

    public get editor () {
        return this.$refs.editor.editorInstance
    }

    public get options () {
        return {
            usageStatistics: false,
            includeUI: {
                loadImage: {
                    path: `${this.media.url}?t=${this.media.updateAt.getTime() / 1000}`,
                    name: this.media.title || this.media.originalName || `Imagen ${this.media.id}`,
                },
                locale: {
                    'Crop': 'Recortar',
                    'Delete': 'Eliminar',
                    'Remove White': 'Eliminar blanco',
                    'Brightness': 'Luminosidad',
                    'Noise': 'Ruido',
                    'Pixelate': 'Pixelar',
                    'Color Filter': 'Filtro de color',
                    'Tint': 'Tinte',
                    'Multiply': 'Multiplicar',
                    'Blend': 'Mezcla',
                    'Distance': 'Distancia',
                    'Threshold': 'Límite',
                    'Load Mask Image': 'Carga máscara de imagen',
                    'Bold': 'Negrita',
                    'Italic': 'Itálica',
                    'Underline': 'Subrayado',
                    'Left': 'Izquierda',
                    'Center': 'Centro',
                    'Right': 'Derecha',
                    'Heart': 'Corazón',
                    'Bubble': 'Burbuja',
                    'Location': 'Ubicación',
                    'DeleteAll': 'Eliminar todo',
                    'Undo': 'Rehacer',
                    'Redo': 'Deshacer',
                    'Flip': 'Voltear',
                    'Rotate': 'Rotar',
                    'Draw': 'Dibujar',
                    'Shape': 'Forma',
                    'Icon': 'Icono',
                    'Text': 'Texto',
                    'Mask': 'Máscara',
                    'Filter': 'Filtro',
                    'Reset': 'Resetear',
                    'Apply': 'Aplicar',
                    'Cancel': 'Cancelar',
                    'Custom': 'Personalizado',
                    'Square': 'Cuadrado',
                    'FlipX': 'Voltear X',
                    'FlipY': 'Voltear Y',
                    'Range': 'Rango',
                    'Arrow': 'Flecha',
                    'Free': 'Libre',
                    'Text size': 'Tamaño del texto',
                    'Straight': 'Linea recta',
                    'Custom icon': 'Icono personalizado',
                    'Grayscale': 'Escala de grises',
                    'Invert': 'Invertir',
                    'Blur': 'Difuminar',
                    'Sharpen': 'Afilar',
                    'Emboss': 'Realzar',
                    'Flip X': 'Voltear X',
                    'Flip Y': 'Voltear Y',
                    'Rectangle': 'Rectángulo',
                    'Triangle': 'Triangulo',
                    'Circle': 'Circulo',
                    'Fill': 'Relleno',
                    'Stroke': 'Trazo',
                    'Star-1': 'Estrella',
                    'Star-2': 'Estrella 2',
                    'Arrow-2': 'Flecha 2',
                    'Arrow-3': 'Flecha 3',
                    'Polygon': 'Polígono',
                },
                menuBarPosition: 'bottom',
            },
        }
    }

    /**
     * Guarda los cambios de la imagen
     */
    public async save () {
        this.saving = true

        await this.$store.dispatch('media/saveMediaObjectFile', {
            file: this.getImage(),
        })

        this.saving = false
        this.saveConfirm = false

        notify('El archivo se ha guardado correctamente')
    }

    /**
     * Genera un blob que contiene la imagen actualmente cargada en el editor
     *
     * @return { Blob }
     */
    public getImage (): Blob {
        const dataURI = this.editor.toDataURL({
            format: this.media.mimeType.split('/')[1],
        })

        return this.dataURItoBlob(dataURI)
    }

    /**
     * Crea un Blob a partir de un data URI
     *
     * @param uri
     */
    public dataURItoBlob (uri: string) {
        const byteString = atob(uri.split(',')[1]);
        const mimeString = uri.split(',')[0].split(':')[1].split(';')[0];

        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }


        return new Blob([ab], {type: mimeString});
    }

    public errorCaptured () {
        this.saving = false
        this.saveConfirm = false
    }
}
